<nav *ngIf="currentUser" class="navbar navbar-default navbar-fixed-top" role="navigation" id="header-nav">
  <div class="container-fluid" id="header-link-list-div">
    <div class="navbar-header" id="header-branding-container">
        <h1 class="logo">
            <span>North Carolina Judicial Branch</span>
        </h1>
        <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#ciprsNavbar" id="header-collapse-btn">
            <img src="assets/images/collapse_menu.svg">
        </button>
    </div>
    <div class="collapse navbar-collapse" id="ciprsNavbar">
      <ul class="nav navbar-nav navbar-right" *ngIf="!isViewOutletActivated()" data-toggle="collapse" data-target="#ciprsNavbar">
        <li><a id="header-about-lnk" tabindex="12" (click)="openAbout()">About</a></li>
        <li *ngIf="showCartLink()"><a id="header-cart-lnk" tabindex="14" (click)="openCart()">
          <i class="glyphicon glyphicon-shopping-cart"></i> Cart <span *ngIf="cartSize" class="badge">{{cartSize}}</span>
          </a>
        </li>
        <li *ngIf="showClearHistory()"><a  id="header-clear-history-lnk" tabindex="17" (click)="openClearHistory()">Clear History</a></li>
        <li><div *ngIf="true; then userTemplate"></div></li>
      </ul>
      <ul class="nav navbar-nav navbar-right" *ngIf="isDetailsViewOutletActivated()" data-toggle="collapse" data-target="#ciprsNavbar">
          <li *ngIf="showCartReleatedDetailsOptions() && !isCaseInCart()"><a tabindex="20" id="add-to-cart-lnk" (click)="addCaseToCart()"><span class="glyphicon glyphicon-shopping-cart"></span> Add to Cart</a></li>
          <li *ngIf="showCartReleatedDetailsOptions() && isCaseInCart()"><a tabindex="20" id="remove-from-cart-lnk" (click)="removeCaseFromCart()"><span class="glyphicon glyphicon-shopping-cart"></span> Remove from Cart </a></li>
          <li *ngIf="showCartReleatedDetailsOptions()"><a tabindex="22" id="on-email-case-lnk" (click)="onEmailClicked()"><span class="glyphicon glyphicon-envelope"></span> Email </a></li>
          <li *ngIf="showCartReleatedDetailsOptions()"><a tabindex="23" id="on-print-case-lnk" (click)="onPrintClicked()"><span class="glyphicon glyphicon-print"></span> Print </a></li>
          <li *ngIf="showHelpLink()"><a tabindex="24" id="on-open-help-lnk" (click)="openHelp()"><span class="glyphicon glyphicon-question-sign"></span> Help </a></li>
          <li><div *ngIf="true; then userTemplate"></div></li>
      </ul>
      <ng-template #userTemplate>
          <div *ngIf="showLoggedInUser()" id="user-dropdown" class="dropdown">
              <a  aria-expanded="false" aria-haspopup="true" class="dropdown-toggle" data-toggle="dropdown" href="#" id="user-dropdown-lnk" role="button" tabindex="18"><span class="glyphicon glyphicon-user"></span> {{currentUser.user.commonName}}<span class="caret"></span></a>
              <ul class="dropdown-menu">
                <li><a (click)="logout()" href="javascript:void(0)" id="header-logout-btn" tabindex="19">Log out</a></li>
              </ul>
            </div>
      </ng-template>
    </div>
  </div>
  <div id="header-divider-line"></div>
  <ul class="nav navbar-nav" *ngIf="isViewOutletActivated()">
      <li><a  id="header-back-lnk" tabindex="25" (click)="onBackClicked()"><span class="glyphicon glyphicon-arrow-left"></span> Back</a></li>
    </ul>
  <ul class="nav navbar-nav" *ngIf="showHomeLink()">
      <li><a id="header-home-lnk" tabindex="25" [routerLink]="['/']"><span class="glyphicon glyphicon-arrow-left"></span> Home</a></li>
  </ul>
</nav>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/header/header.component.html